<div *ngIf="isOpen"  class="open-close-container" [ngClass]="{'blur': withBlur}" (click)="close(false)">
  <div class="container" [@slideInOut]="{value: true, params:{from:from, to:to}}">
    <ng-container #container></ng-container>
  </div>
</div>
